import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { Sun, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  useSeo({ status: 404, title: "Page not found | SunBiz", description: "That page does not exist on sunbizcon.com.", robots: "noindex, nofollow" });
  return (
    <div
      data-testid="not-found-page"
      style={{
        minHeight: "100vh", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: "18px",
        background: "#F5F8F5", color: "#0F2A1D", fontFamily: "Manrope, sans-serif",
        padding: "24px", textAlign: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
        <div style={{ width: "40px", height: "40px", borderRadius: "10px", background: "#F59E0B", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Sun size={22} color="#0F2A1D" />
        </div>
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: "16px", fontWeight: 800, fontFamily: "Outfit, sans-serif" }}>SunBiz</div>
          <div style={{ fontSize: "10px", letterSpacing: "1px", color: "#6B8577", textTransform: "uppercase" }}>By Sun Bizcon</div>
        </div>
      </div>
      <div style={{ fontSize: "72px", fontWeight: 800, color: "#2F7D52", lineHeight: 1, fontFamily: "Outfit, sans-serif" }}>404</div>
      <h1 style={{ fontSize: "22px", fontWeight: 700, margin: 0 }}>Page not found</h1>
      <p style={{ fontSize: "14px", color: "#6B8577", maxWidth: "420px", margin: 0 }}>
        The page you're looking for doesn't exist or has moved.
      </p>
      <div style={{ display: "flex", gap: "12px", marginTop: "8px", flexWrap: "wrap", justifyContent: "center" }}>
        <Link
          to="/app/dashboard"
          data-testid="not-found-dashboard-link"
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "11px 22px", borderRadius: "100px", background: "#2F7D52", color: "#fff", textDecoration: "none", fontWeight: 600, fontSize: "14px" }}
        >
          <ArrowLeft size={16} /> Back to dashboard
        </Link>
        <Link
          to="/"
          data-testid="not-found-home-link"
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "11px 22px", borderRadius: "100px", background: "#fff", color: "#2F7D52", border: "1px solid rgba(47,125,82,0.3)", textDecoration: "none", fontWeight: 600, fontSize: "14px" }}
        >
          Go to homepage
        </Link>
      </div>
    </div>
  );
}
